import { createAction, props } from '@ngrx/store';

export enum Types {
  // Error
  UPDATE_ERROR = '[App State] Update Error',
  // Booleanos
  UPDATE_RETURN_HOME = '[App State] Update Return Home',
  UPDATE_LOGIN_IN_PROCESS = '[App State] Update Login In Process',
  UPDATE_VERIFY_TOTP_IN_PROGRESS = '[App State] Update Verify Totp In Process',
  UPDATE_SHOW_CLIENTS_REQUESTS = '[App State] Update Show Clients Requests',
}

// Error
export const updateError =                createAction(Types.UPDATE_ERROR,                    props<{ error: any }>());
// Booleanos
export const updateReturnHome =           createAction(Types.UPDATE_RETURN_HOME,              props<{ returnHome: boolean }>());
export const updateLoginInProcess =       createAction(Types.UPDATE_LOGIN_IN_PROCESS,         props<{ loginInProcess: boolean }>());
export const updateVerifyTotpInProcess =  createAction(Types.UPDATE_VERIFY_TOTP_IN_PROGRESS,  props<{ verifyTotpInProcess: boolean }>());
export const updateShowClientsRequests =  createAction(Types.UPDATE_SHOW_CLIENTS_REQUESTS,    props<{ showClientsRequests: boolean }>());